import React, { Component } from 'react';

//import ReactP5Wrapper from "react-p5-wrapper";
import ReactP5Wrapper from "./P5Wrapper";
import scopeScript from "../../utils/sketchScope";
import artworkInput from "../../utils/artworkInput";
import artworkControlProfile from '../../utils/artworkControlProfile';
import ArtworkControls from '../ArtworkControls/ArtworkControls';

import './P5Cell.css';
import OwnerCaption from "../OwnerCaption/OwnerCaption";

class P5Cell extends Component {

  constructor(props) {
    super(props);

    this.state = {
      token: this.props.token,
      square: this.props.square,
      script: this.props.script,
    }
    this.onClick = this.onClick.bind(this);
  }

  buildSketch = async (script) => {
    if (!script) {
      return null;
    }
    try {
      const profile = await artworkControlProfile(script, this.props.token && this.props.token.projectId);
      // Only a hash-verified profile may name a private state binding. New
      // projects expose their own public getState() through the conventions.
      const inspect = profile.source === 'reviewed' && profile.stateBinding === 'state' ? '\nreturn () => state;' : '';
      const sketch = new Function('p', 'window', scopeScript(script) + inspect);
      return p => artworkInput(p, sketch, profile);
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  loadSketch = async script => {
    const request = this._sketchRequest = (this._sketchRequest || 0) + 1;
    const sketch = await this.buildSketch(script);
    if (!this._unmounted && request === this._sketchRequest) this.setState({ sketch });
  }

  componentDidMount() {
    this.loadSketch(this.state.script);
  }

  shouldComponentUpdate(nextProps, nextState) {
    // State must be compared as well as props, not just the sketch. The incoming
    // props are copied into state by componentDidUpdate, and that setState
    // arrives with props unchanged — so a props-only test rejects it, the render
    // carrying the new square never happens, and the wrapper never tells the art
    // script to resize. The result was that cells already on screen kept their
    // original size while newly minted ones came in at the new one.
    return (
      this.props.token !== nextProps.token ||
      this.props.square !== nextProps.square ||
      this.props.script !== nextProps.script ||
      this.props.ownerOfSelectedEdition !== nextProps.ownerOfSelectedEdition ||
      this.state.token !== nextState.token ||
      this.state.square !== nextState.square ||
      this.state.script !== nextState.script ||
      this.state.sketch !== nextState.sketch
    );
  }

  componentDidUpdate(prevProps) {
    //console.logs.length = 0;

    if (prevProps.token !== this.props.token || prevProps.square !== this.props.square || prevProps.script !== this.props.script) {
      const nextState = {
        token: this.props.token,
        script: this.props.script,
        square: this.props.square
      };
      if (prevProps.script !== this.props.script) {
        nextState.sketch = null;
        this.loadSketch(this.props.script);
      }
      this.setState(nextState);
    }


  }

  componentWillUnmount() {
    this._unmounted = true;
    document.removeEventListener("click", this.onClick);
  }

  onClick(e) {
    e.preventDefault();
    //alert(this.state.indexValue);
    this.props.handleClick(this.props.indexValue);
  };

  render() {

    const selected = this.props.selected;

    return (
      (this.state.token && this.state.sketch) ? (
        (selected) ? (
          <div
            //className='cell'
            className={`cell ${selected && 'selected'}`}
            id={this.state.token.transactionHash}
            >
            <ReactP5Wrapper ref={player => { this.player = player; }} sketch={this.state.sketch}
                            square={this.state.square}
                            projectId={this.state.token.projectId}
                            editionId={this.state.token.editionId}
                            tokenId={this.state.token.tokenId}
                            transactionHash={this.state.token.transactionHash}
                            onSketchReady={this.props.onSketchReady}/>

            <ArtworkControls projectId={this.state.token.projectId}
              getControls={() => this.player && this.player.canvas && this.player.canvas.artworkControls} />

            <div className="fade-in-text">
              <OwnerCaption
                tokenId={this.state.token.tokenId}
                owner={this.props.ownerOfSelectedEdition}
                asOf={this.props.ownerAsOf}
              />
            </div>
          </div>


          
      ) : (
          <div
            //className='cell'
            className={`cell ${selected && 'selected'}`}
            id={this.state.token.transactionHash}
            onClick={this.onClick}
            >
            <ReactP5Wrapper sketch={this.state.sketch}
                            square={this.state.square}
                            projectId={this.state.token.projectId}
                            editionId={this.state.token.editionId}
                            tokenId={this.state.token.tokenId}
                            transactionHash={this.state.token.transactionHash}
                            onSketchReady={this.props.onSketchReady}/>

          </div>
      )
    ) : (
      <div
        //className='cell'
        className={`cell ${selected && 'selected'}`}
        //onClick={this.onClick}
        >
      </div>
    )
    );
  };
}

export default P5Cell;
